import styled from 'styled-components';

export const ButtonDiv = styled.div`
  margin: 1px;
`;
